import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { ABOUT_META } from '../data/meta'

export default function About() {
  return (
    <>
      <SEO
        title={ABOUT_META.title}
        description={ABOUT_META.description}
        canonical={ABOUT_META.canonical}
        keywords={ABOUT_META.keywords}
        structuredData={ABOUT_META.structuredData}
      />
      <Navbar />
      <section className="about-page">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">About Us</span>
            <h1 className="page-title">We Started <span className="gradient-text">TRED-EX AI</span> to Democratize AI for Businesses</h1>
<p className="page-description">
              Most businesses now know AI is powerful, but too many still think it's only for big corporations with big budgets. We're here to change that.
            </p>
          </div>

          <div className="about-story">
            <div className="about-story-content">
              <h2>Our Story</h2>
              <p>
                TRED-EX AI was founded in 2024 by a team of engineers and marketers who saw a massive gap: Businesses were being left behind in the AI revolution.
              </p>
              <p>
                While enterprise companies spent millions on custom AI solutions, businesses of every size were stuck with static websites that couldn't even answer basic customer questions after hours. From a local restaurant to a growing retail chain, most sites left visitors waiting for answers they never got.
              </p>
              <p>
                We asked ourselves: <em>"What if every business could afford AI features on their website?"</em>
              </p>
              <p>
                That question became TRED-EX AI. We built a service model that lets us install, maintain, and optimize AI features for businesses of every size at fixed, predictable prices and no enterprise contracts, no PhD required.
              </p>
            </div>
            <div className="about-story-visual">
              <div className="about-story-card">
                <div className="about-story-icon"><i className="fas fa-heart"></i></div>
                <h3>Our Mission</h3>
                <p>Democratize AI for Businesses. No jargon, no hidden fees, no long term lock-ins. Just practical AI features that drive real results.</p>
              </div>
            </div>
          </div>

          <div className="values-section">
            <h2 className="values-title">Our Values</h2>
            <div className="values-grid">
              {[
                { icon: 'fa-handshake', title: 'Transparency', desc: 'Clear pricing, honest timelines, and no surprise bills. We explain everything in plain language.' },
                { icon: 'fa-chart-line', title: 'Results-Driven', desc: 'We don\'t sell "AI for AI\'s sake." Every feature we install must move a business metric leads, conversions, or retention.' },
                { icon: 'fa-comments', title: 'No Jargon', desc: 'We speak human, not robot. Our proposals, reports, and support are designed for business owners, not engineers.' },
                { icon: 'fa-lock', title: 'Trust & Security', desc: 'Your data and your customers\' data are sacred. We follow industry best practices for security and privacy.' },
              ].map((value, i) => (
                <div className="value-card" key={i}>
                  <div className="value-icon"><i className={`fas ${value.icon}`}></i></div>
                  <h3>{value.title}</h3>
                  <p>{value.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="why-us-section">
            <h2 className="why-us-title">Why Choose TRED-EX AI?</h2>
            <div className="why-us-grid">
              {[
                { icon: 'fa-bolt', title: 'Fast Deployment', desc: 'Most features go live in 7-14 days, not months. We respect your timeline.' },
                { icon: 'fa-rupee-sign', title: 'Fixed Pricing', desc: 'No hourly billing surprises. One-time setup fee + predictable monthly maintenance.' },
                { icon: 'fa-headset', title: 'Dedicated Support', desc: 'Real humans answer your questions. No ticket queues, no outsourced support.' },
                { icon: 'fa-rocket', title: 'Built for Every Business', desc: 'From local shops to growing enterprises, we tailor AI features to your industry and goals.' },
                { icon: 'fa-chart-bar', title: 'Proven Results', desc: '200% businesses transformation. 40% more leads on average. 60% fewer support tickets.' },
                { icon: 'fa-sync', title: 'Continuous Optimization', desc: 'We don\'t install and disappear. Monthly tuning ensures your AI keeps getting better.' },
              ].map((item, i) => (
                <div className="why-us-card" key={i}>
                  <div className="why-us-icon"><i className={`fas ${item.icon}`}></i></div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-bottom-cta">
            <h2>Ready to see what AI can do for your business?</h2>
            <p>Get a free AI audit of your website. No commitment, no sales pitch. Just actionable insights.</p>
                                    <Link to="/contact" className="btn btn-primary btn-lg">Send <i className="fas fa-paper-plane"></i></Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
